import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const LoginProtectedRoute = (props) => {
  const navigate = useNavigate();
  const userToken = useSelector((state) => state.entities.auth.userToken);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const checkUserToken = () => {
    if (userToken) return navigate("/");
    else setIsLoggedIn(true);
  };

  useEffect(() => {
    checkUserToken();
  }, []);

  return <React.Fragment>{isLoggedIn ? props.children : null}</React.Fragment>;
};
export default LoginProtectedRoute;
